import "./post.scss";
import React from "react";

interface IPost {
    children: React.ReactNode;
}

const Post = ({children}: IPost) => {
    return (
        <div className="Post">
            <div className="Post-Header d-flex align-items-center justify-content-between">
                <img src={require("../../assets/images/icons/More.svg").default} alt="" className="img-fluid"/>
                <div className="Post-Header-User">
                    <span>vidomovoe</span>
                    <img src={require("../../assets/images/avatars/Avatar7.png")} alt="" className="img-fluid"/>
                </div>
            </div>
            <div className="Post-Body">
                {children}
            </div>
            <div className="Post-Footer d-flex align-items-center justify-content-between">
                <img src={require("../../assets/images/icons/Save.svg").default} alt="" className="img-fluid"/>
                <div>
                    <img src={require("../../assets/images/icons/Share.svg").default} alt="" className="img-fluid"/>
                    <img src={require("../../assets/images/icons/Comment.svg").default} alt=""
                         className="img-fluid px-3"/>
                    <img src={require("../../assets/images/icons/Like.svg").default} alt="" className="img-fluid"/>
                </div>
            </div>
        </div>
    );
}

export default Post;